module.exports = __webpack_public_path__ + "img/y.39b89093.jpg";